import { eventStatusTypes } from "pages/event/utils";
import { getInterval, getDefaultSportEventValues, getDefaultMatchPointConfigValues } from "../../utils";

export default ({
  hasAdminPrivileges,
  isSportEvent,
  userEmail,
  userLocale,
  contractId = undefined,
  customerId = undefined,
}) => {
  const [startDate, endDate] = getInterval();
  return {
    title: "",
    description: "",
    startDate,
    endDate,
    isMutedOnStart: false,
    unmuteMinutesBefore: 5,
    keywords: [],
    billable: !hasAdminPrivileges,
    visible: !hasAdminPrivileges,
    liveStreams: [],
    localRec: false,
    activeQod: false,
    typeId: undefined,
    contractId,
    customerId,
    graphicSetId: undefined,
    roomTemplateId: undefined,
    sportEventData: {
      teamLogo1: "",
      teamLogo2: "",
    },
    eventStatus: eventStatusTypes.CREATED,
    ...getDefaultSportEventValues(isSportEvent),
    ...getDefaultMatchPointConfigValues(isSportEvent),
    emailReceipts: [{ email: userEmail, locale: userLocale }],
  };
};
